import styled from "styled-components";

import theme from "../../../theme";

const ErrorBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${theme.colors.red};
  opacity: 0.7;
  color: ${theme.colors.white};
  min-height: 36px;
  font-size: ${theme.fontSizes.small};
  padding: 8px;
  text-align: center;
  line-height: 16px;
  margin-bottom: 12px;
`;

export default ErrorBlock;
